module.exports = __webpack_public_path__ + "static/img/ic_certificate_e.0c138817.png";